import {useMatchMedia} from '@pexip/hooks';

import {XL_DOWN} from '../../constants/mediaQueries';

export const useXlDown = () => useMatchMedia(XL_DOWN);
